const SuccessCriteria = require('./success-criteria');
const uievents = require('../ui/events');
const Expandable = require('../ui/expandable');
const Renameable = require('../../lib/util/behaviors/renameable');
const ListItemMenu = require('../ui/list-item-menu');
const MenuItem = require('../ui/list-menu-item');
const CardPreview = require('../ui/card-preview');
const template = require('./tactic.tpl').default;

module.exports = DomClass(template, function Tactic() {
    var _t = this;

	Expandable.call(this, this.expandHeader);
	var onstartrename = Renameable.call(this);

	var onchange = on(this, 'change');
	var onremove = on(this, 'remove');

	this.toJSON = () => ({
		name: this.name,
		quantityNeeded: this.quantityNeeded,
		turnNeeded: this.turnNeeded
	});

	this.recount = function(deck) {
		var cards = deck.cards.filter(function(card) {
			return card.tactics[_t.name];
		});

		_t.cards = cards.map(function(card) {
			// why the hell does this need to be copied!?
			// ... there is most def's a TG-DOM bug a-happenin' here...
			// (If this isn't copied, CardPreview applies itself over the
			// existing nodes, which screws things up.)
			return new CardPreview({ target: card });
		});

		_t.count = cards.reduce(function(total, card) {
			return total + Number(card.activeQuantity);
		}, 0);
	};

	this.compareTo = function(other) {
		if (this.turnNeeded == other.turnNeeded) {
			return other.quantityNeeded - this.quantityNeeded;
		} else {
			return this.turnNeeded - other.turnNeeded;
		}
	}

	this.remove = function() {
		onremove.fire();
	};

	this.lock = function() {
		this.classList.add('locked');
		this.__dom.quantityNeeded.readOnly = true;
		this.__dom.turnNeeded.readOnly = true;
	};

	this.unlock = function() {
		this.classList.remove('locked');
		this.__dom.quantityNeeded.readOnly = false;
		this.__dom.turnNeeded.readOnly = false;
	};

	this.__dom.quantityNeeded.onchange = function() {
		onchange.fire(_t);
	};

	this.__dom.turnNeeded.onchange = function() {
		onchange.fire(_t);
	};

	this.menu.items = [
		new MenuItem({name: 'Rename', target: function() { onstartrename.fire(); } }),
		new MenuItem({name: 'REMOVE', target: function() { _t.remove(); }})
	];

});
